import React from "react";

import Loader from "react-loader-spinner";

function Preloader() {
  return (
    <Loader
      type="ThreeDots"
      color="#C2A750"
      height={50}
      width={50}
      className="col v-px-8 v-text-align-center "
    />
  );
}

export default Preloader;
